export const PATH_GETTERS = Object.freeze({
    PATHS: "paths",
    USER_PATHS: "userPaths",
    SELECTED_PATHS: "selectedPaths",
    GET_SELECTED_PATHS: "getSelectedPath"
});
